import React from "react";
import { Button } from "@mui/material";

const ButtonYellow = ({
  children = "+ Nouveau processus",
  onClick,
  type = "button",
  ...buttonProps
}) => {
  return (
    <Button
      {...buttonProps}
      onClick={onClick}
      type={type}
      sx={{
        backgroundColor: "#d5ad3f",
        borderRadius: "7px",
        boxShadow: "none",
        color: "#071a2c",
        fontFamily: "'DM Sans', sans-serif",
        fontSize: "12px",
        fontWeight: 700,
        height: "38px",
        lineHeight: 1,
        minWidth: "165px",
        padding: "0 18px",
        textTransform: "none",
        whiteSpace: "nowrap",
        "&:hover": {
          backgroundColor: "#c79d31",
          boxShadow: "none",
        },
        "&:focus-visible": {
          outline: "3px solid rgba(13, 39, 64, 0.25)",
          outlineOffset: "2px",
        },
        "&.Mui-disabled": {
          backgroundColor: "#e1c777",
          color: "rgba(7, 26, 44, 0.55)",
        },
      }}
    >
      {children}
    </Button>
  );
};

export default ButtonYellow;
